import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';

const useStyles = makeStyles(theme => ({
  headerWrapper: { marginBottom: theme.spacing(4) }
}));

const Header = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.headerWrapper} {...rest}>
      <Typography component="h1" variant="h1">
        {children}
      </Typography>
    </div>
  );
};

Header.propTypes = {
  children: PropTypes.string
};

export default Header;
